import BaseAPI from '../base/baseApi';
import httpclient from '../base/httpclient';
import SystemApi from './_systemApi';

class DatabaseAPI extends BaseAPI {
  controllerName = 'Databases';
  apiName = 'E';
  /**
   * API lấy dữ liệu theo id
   * ndhieu3 23.05.2023
   * @param {*} id
   */
  getById(id) {
    const request = {
      url: this.getAPIUrl() + '/' + id,
    };
    return httpclient.getAsync(request);
  }
  /**
   * API đổi database
   * ndhieu3 19.06.2023
   * @param {*} payload
   * @returns
   */
  changeDatabase(payload) {
    const request = {
      url: [
        this.getAPIUrl(),
        '/change-database',
        `?userId=${payload.userId}&databaseId=${payload.databaseId}&tenantId=${payload.tenantId}`,
      ].join(''),
    };
    return httpclient.putAsync(request, true);
  }

  /**
   * Tạo dữ liệu lần đầu login
   * @param {*} payload
   * @returns
   * nvxuan 14.09.2023
   */
  createDataFirstLogin(payload) {
    const request = {
      url: [this.getAPIUrl(), '/create-db-first-login'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Tạo dữ liệu mới
   * @param {*} payload
   * @returns
   * nvxuan 21.09.2023
   */
  createNewDatabase(payload) {
    const request = {
      url: [this.getAPIUrl(), '/create-new-db'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  validateDuplicateDatabaseName(databaseName) {
    const request = {
      url: [this.getAPIUrl(), '/validate-duplicate', `?databaseName=${databaseName}`].join(''),
    };
    return httpclient.postAsync(request);
  }

  getByTenantAndUserId(tenantId, userId, isActive = true) {
    const request = {
      url: [
        this.getAPIUrl(),
        '/list-by-tenant-and-user',
        `?tenantId=${tenantId}&userId=${userId}&isActive=${isActive}`,
      ].join(''),
    };
    return httpclient.getAsync(request);
  }

  /**
   * @description Lấy dữ liệu đang được sử dụng theo tài khoản và đơn vị
   * @param {*} tenantId
   * @param {*} userId
   * @returns {Array} Danh sách dữ liệu sắp xếp theo ngày tạo
   * @author nvthinh 5.2.2025
   */
  getUsingDBsByTenantAndUser(tenantId, userId) {
    const request = {
      url: [this.getAPIUrl(), '/list-db-by-tenant-and-user', `?tenantId=${tenantId}&userId=${userId}`].join(''),
    };
    return httpclient.getAsync(request);
  }

  /**
   * lấy danh sách các database khác
   * vqphong - 26/03/2024
   */
  getOtherDatabasesByTenantAndUserId() {
    const request = {
      url: [this.getAPIUrl(), '/other-list-by-tenant-and-user'].join(''),
    };
    return httpclient.getAsync(request);
  }

  getByUserId(userId, isActive = true) {
    const request = {
      url: [this.getAPIUrl(), '/list-by-tenant-and-data', `?userId=${userId}&isActive=${isActive}`].join(''),
    };
    return httpclient.getAsync(request);
  }

  /**
   * Lấy thông tin dboption của db có dbstartdate,dbclosedate
   * ndhieu3 26.09.2023
   * @param {} databaseId
   */
  getInfoDb(databaseId) {
    const request = {
      url: [this.getAPIUrl(), '/info', `?database_id=${databaseId}`].join(''),
    };
    return httpclient.getAsync(request);
  }
  /**
   * Thêm mới database_user
   * pdtai 25.05.2023
   */
  insertDatabaseUser(payload) {
    const request = {
      url: [this.getAPIUrl(), '/database-user'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Lấy danh sách các bản ghi backup theo dbid
   * @param {*} payload
   * @returns
   * nvxuan 20.11.2023
   */
  getBackupByDbId(payload) {
    const request = {
      url: [this.getAPIUrl(), '/get-backup-by-db-id'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Kiểm tra dữ liệu trước khi backup
   * @param {*} payload
   * @returns
   * nvxuan 24.11.2023
   */
  checkBeforeBackup(payload) {
    const request = {
      url: [this.getAPIUrl(), '/check-before-backup'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Thực hiện backup dữ liệu
   * @param {*} payload
   * @returns
   * nvxuan 20.11.2023
   */
  executeBackupData(payload) {
    const request = {
      url: [this.getAPIUrl(), '/backup-data'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Thực hiện tạo mới dữ liệu từ dữ liệu cũ
   * @param {*} payload
   * @returns
   * tvtoan 09.01.2024
   */
  executeCreateDataFromOldData(payload) {
    const request = {
      url: [this.getAPIUrl(), '/create-database-from-old-data'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Hủy sao lưu dữ liệu
   * @param {*} id
   * @returns
   * nvxuan 20.11.2023
   */
  async cancelBackupData(id) {
    const request = {
      url: [this.getAPIUrl(), 'cancel-backup-data', id].join('/'),
    };
    return httpclient.getAsync(request, true);
  }

  /**
   * Hủy khôi phục dữ liệu
   * @param {*} id
   * @returns
   * nvxuan 20.11.2023
   */
  async cancelRestoreData(id) {
    const request = {
      url: [this.getAPIUrl(), 'cancel-restore-data', id].join('/'),
    };
    return httpclient.getAsync(request, true);
  }

  /**
   * Lấy bản ghi backup theo id
   * nvxuan 20.11.2023
   */
  async getBackupById(id) {
    const request = {
      url: [this.getAPIUrl(), 'get-backup-by-id', id].join('/'),
    };
    return httpclient.getAsync(request, true);
  }

  /**
   * Lấy thông tin tiến trình tạo database từ dữ liệu cũ
   * tvtoan 23.01.2024
   */
  async getInfoProcessCreateData(id) {
    const request = {
      url: [this.getAPIUrl(), 'get-info-process-create-data', id].join('/'),
    };
    return httpclient.getAsync(request, true);
  }

  /**
   * Lấy thông tin tiến trình tạo database từ dữ liệu cũ
   * tvtoan 23.01.2024
   */
  async getAllProcessCreateData(id) {
    const request = {
      url: [this.getAPIUrl(), 'get-all-process-create-data', id].join('/'),
    };
    return httpclient.getAsync(request, true);
  }

  /**
   * Lấy bản ghi restore theo id
   * nvxuan 22.11.2023
   */
  async getRestoreById(id) {
    const request = {
      url: [this.getAPIUrl(), 'get-restore-by-id', id].join('/'),
    };
    return httpclient.getAsync(request, true);
  }

  /**
   * Lấy dữ liệu danh sách các bản sao lưu theo tenant
   * nvxuan 22.11.2023
   */
  async getBackupByTenant(tenantId) {
    const request = {
      url: [this.getAPIUrl(), 'get-backup-by-tenantid', tenantId].join('/'),
    };
    return httpclient.getAsync(request, true);
  }

  /**
   * Xóa bản sao lưu dữ liệu
   * NVXUAN 22.11.2023
   */
  async removeBackupRecord(payload) {
    const request = {
      url: [this.getAPIUrl(), 'remove-backup-record'].join('/'),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Thực hiện khôi phục dữ liệu
   * nvxuan 20.11.2023
   */
  async executeRestoreData(payload) {
    const request = {
      url: [this.getAPIUrl(), '/restore-data'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Lấy bản ghi đang khôi phục theo người dùng và ID bản sao lưu
   * nvxuan 23.11.2023
   */
  async getRestoringByUserIdBackupId(payload) {
    const request = {
      url: [this.getAPIUrl(), '/get-restoring-by-user-backup'].join(''),
      data: payload,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Kiểm tra xem người dùng userId có quyền admin tại database dbId hay không
   * @param {*} userId
   * @param {*} dbId
   * nvxuan 11.12.2023
   */
  async checkIsAdminByDatabaseId(userId, dbId) {
    const request = {
      url: [this.getAPIUrl(), '/check-is-admin-by-dbid', '?userId=', userId, '&dbId=', dbId].join(''),
    };
    return httpclient.getAsync(request, true);
  }

  /**
   * Thực hiện xóa bỏ các db bị lỗi
   * @param {*} databaseId
   * @returns
   * npcuong 29.02.2024
   */
  async deleteErrorDatabase(databaseId) {
    const request = {
      url: [this.getAPIUrl(), '/error-database?databaseId=', databaseId].join(''),
      databaseId: databaseId,
    };
    return httpclient.postAsync(request, true);
  }

  /**
   * Lấy lịch sử quản lý dữ liệu
   * @param {Date} fromDate Từ ngày
   * @param {Date} toDate Đến ngày
   * @returns {Promise} Kết quả trả về từ API
   */
  async getDatabaseHistory(fromDate, toDate) {
    const request = {
      url: [this.getAPIUrl(), '/history/filter'].join(''),
      data: {
        from_date: fromDate,
        to_date: toDate,
      },
    };
    return httpclient.postAsync(request, true);
  }
}

export default new DatabaseAPI();
